<template lang="pug">
  #app.clearfix
    navbar.clearfix.navbar.navbar-default(
      v-if="authed && $route.path !== '/login'"
      placement='top'
      type='default')
      a.navbar-brand(slot='brand' v-link="{name: 'index'}")
        span(style="color:#ffcb2f") Controller
        span Hub
      dropdown(
        v-bind:class="{'active': $route.path.includes('smart-controller')}"
        text='Smart-controller'
        v-if="user.custom === 'all' || user.custom === 'gomax'"
      )
        li(v-bind:class="{'active': $route.path.includes('/smart-controller/production') && !$route.path.includes('/smart-controller/production-activity')}")
          a(v-link="{path: '/smart-controller/production'}")
            | Production
        li(v-bind:class="{'active': $route.path.includes('/smart-controller/production-activity')}")
          a(v-link="{path: '/smart-controller/production-activity'}" v-if="user.role === 'admin'")
            | Production Activity
        li(v-bind:class="{'active': $route.path.includes('/smart-controller/firmware')}")
          a(v-link="{path: '/smart-controller/firmware'}")
            | Firmware
        li(v-bind:class="{'active': $route.path.includes('/smart-controller/history')}")
          a(v-link="{path: '/smart-controller/history'}")
            | History
      dropdown(v-bind:text='user.email' slot='right')
        li
          a(@click="logout")
            i.fa.fa-sign-out
            | &nbsp;Logout
        li
          a Ver. {{ version }}
    .main
      router-view
    alert(
      v-bind:type="alertData.type"
      v-bind:show.sync="alertData.show"
      v-bind:duration="1000"
      width="280px"
      placement="top-right"
      dismissable)
      span.icon-ok-circled.alert-icon-float-left
      strong {{ alertData.title }}
      p {{ alertData.content }}
</template>

<script>
import { navbar, dropdown, alert } from 'vue-strap'
import { version } from '../package.json'
import { firebaseLogout, AUTH_STATE_AUTHED } from './index'

export default {
  components: {
    navbar,
    dropdown,
    alert
  },
  data: () => ({
    version,
    alertList: [],
    alertData: {
      type: '',
      title: '',
      show: false,
      content: ''
    }
  }),
  vuex: {
    getters: {
      user: state => state.user,
      authed: state => state.authState === AUTH_STATE_AUTHED
    }
  },
  methods: {
    logout () {
      firebaseLogout().then(() => {
        // this.alert('success', '', 'Logout Success')
        window.setTimeout(() => {
          this.$router.go('/login')
        }, 1000)
      })
    },
    alert ({type, title, content}) {
      console.log(type)
      console.log(title)
      console.log(content)
      let newAlert = {
        type,
        title,
        content,
        show: true
      }
      this.alertList.push(newAlert)
    }
  },
  events: {
    alert (e) {
      console.log(e)
      this.alert(e)
    }
  },
  ready () {
    setInterval(() => {  // make alerts wait in list
      if (this.alertList.length) {
        this.alertData = this.alertList.shift()
        this.alertData.show = false
        setTimeout(() => {
          this.alertData.show = true
        }, 1500)
      }
    }, 2000)
  }
}
</script>

<style lang='scss'>
@import './scss/w3.css';
@import './main.scss';
@import "~font-awesome/css/font-awesome.min.css";

html {
  height: 100%;
}

body {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

#app {
  width: 100vw;
  height:  100vh;
}
.main {
  margin-top: 40px;
}

// overwrite the original setting of all dropdowns
.dropdown-menu {
  max-height: 300px;
  overflow: auto;
}

</style>



// WEBPACK FOOTER //
// App.vue?7b9d1a12